module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e43a45d146c95cb23ba247257578a260.png";